import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./Redux/Store/Store";
import axios from "axios";
import { ACTION_LOGIN, ACTION_LOGOUT } from "./Redux/Action/AuthAction";
import { getRoleById } from "./Service/UserService";

import { getLegalInfo } from "./Service/LegalService";
import { isObjectEmpty } from "./Utils/Utils";

const { $ } = window;
const REFRESH_URL = "v1/refresh";
const LOGIN_URL = "v1/login";
const CHANGE_PASSWORD_URL = "v1/user/password/change";
const USERTOKEN = {
  set: (access_token, resfresh_token) => {
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("refresh_token", resfresh_token);
  },
  remove: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  },
  get: () => ({
    access_token: localStorage.getItem("access_token"),
    refresh_token: localStorage.getItem("refresh_token"),
  }),
};

//axios.defaults.baseURL = process.env.REACT_APP_API_URL;
//axios.defaults.baseURL = "https://sfadev.modena.com/api/";
//axios.defaults.baseURL = 'http://localhost:9501/';
//axios.defaults.baseURL = 'http://192.168.3.86:18051/';
axios.defaults.baseURL = "https://salesmhc.modena.com/api/";
let isRefreshing = false;
let failRequests = [];
axios.interceptors.response.use(
  (ok200) => ok200,
  (error) => {
    const {
      config,
      response: { status },
    } = error;
    const originalRequest = config;
    if (status === 401) {
      if (
        config.url === REFRESH_URL ||
        config.url === LOGIN_URL ||
        config.url === CHANGE_PASSWORD_URL
      ) {
        return Promise.reject(error);
      }
      // console.log('ayayayayay');
      if (isRefreshing == false) {
        isRefreshing = true;
        const refreshToken = USERTOKEN.get().refresh_token;
        axios
          .post(REFRESH_URL, { refreshToken })
          .then(async (response) => {
            if (response && response.status == 200) {
              isRefreshing = false;
              let retryCount = Number(localStorage.getItem("retryCount")) || 0;
              if (retryCount >= 3) {
                localStorage.removeItem("retryCount");
                return Promise.reject(error);
              }
              localStorage.setItem("retryCount", retryCount + 1);
              const { access_token, refresh_token } = response.data;
              const [header, payload] = access_token.split(".");
              const userInfo = JSON.parse(atob(payload));
              axios.defaults.headers.common[
                "Authorization"
              ] = `Bearer ${access_token}`;
              USERTOKEN.set(access_token, refresh_token);

              if (userInfo.role_id) {
                const response = await getRoleById(userInfo.role_id);
                const { privileges } = response.data;
                userInfo.privileges = privileges;
              }

              const legal_info = await getLegalInfo();
              if (legal_info.status == 200 && !isObjectEmpty(legal_info.data)) {
                userInfo.legal_name = legal_info.data.legal_name;
                userInfo.legal_code = legal_info.data.legal_code;
                userInfo.legal_affiliates = legal_info.data.legal_affiliates;
              }
              store.dispatch({ type: ACTION_LOGIN, userInfo });
              failRequests.map((callback) => callback(access_token));
            }
          })
          .catch((errorRefresh) => {
            isRefreshing = false;
            $(".modal-backdrop").remove();
            console.log("get refresh token fail", errorRefresh);
            store.dispatch({ type: ACTION_LOGOUT });
            return Promise.reject(error);
          });
      }

      const retryOrigReq = new Promise((resolve, reject) => {
        failRequests.push((token) => {
          originalRequest.headers["Authorization"] = `Bearer ${token}`;
          resolve(axios(originalRequest));
        });
      });

      if (localStorage.getItem("retryCount") <= 3) {
        let retryCount = Number(localStorage.getItem("retryCount")) || 0;
        localStorage.setItem("retryCount", retryCount + 1);
        return retryOrigReq;
      }
      localStorage.removeItem("retryCount");
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

const access_token = localStorage.getItem("access_token");

if (access_token) {
  //get user info from token
  axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
  axios
    .get("v1/user-role")
    .then(async (res) => {
      if (res && res.status == 200) {
        const [header, payload] = access_token.split(".");
        const userInfo = JSON.parse(atob(payload));
        if (userInfo.role_id) {
          const response = await getRoleById(userInfo.role_id);
          const { privileges } = response.data;
          userInfo.privileges = privileges;
        }

        const legal_info = await getLegalInfo();
        if (legal_info.status == 200 && !isObjectEmpty(legal_info.data)) {
          userInfo.legal_name = legal_info.data.legal_name;
          userInfo.legal_code = legal_info.data.legal_code;
          userInfo.legal_affiliates = legal_info.data.legal_affiliates;
        }

        store.dispatch({ type: ACTION_LOGIN, userInfo });
      }
    })
    .catch((error) => {
      console.log("Token invalid", error);
      store.dispatch({ type: ACTION_LOGOUT });
    });
} else {
  store.dispatch({ type: ACTION_LOGOUT });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
